const MAKE_REVIEW_ROOT = '/make-review';

const route = (segment: string, title: string) => ({
  segment,
  title,
  path: segment ? `${MAKE_REVIEW_ROOT}/${segment}` : MAKE_REVIEW_ROOT,
  relativePath: segment ? `/${segment}` : '/',
});

export const MAKE_REVIEW_ROUTES = {
  overview: route('', 'Overview'),
  runs: route('runs', 'Runs'),
} as const;

export const MAKE_REVIEW_TABS = Object.values(MAKE_REVIEW_ROUTES).map(
  ({ path, title }) => ({ id: path, label: title, href: path }),
);

export const MAKE_REVIEW_SUBMENU_ITEMS = [MAKE_REVIEW_ROUTES.runs].map(
  ({ path: to, title }) => ({ title, to }),
);
